import { HStack, Tag } from '@chakra-ui/react'
import { FC } from 'react'

import {
  ArticleCategory,
  categoryColors,
  categoryLabels
} from '@base/variables/help-center/articles'

const allCategories: ArticleCategory[] = [
  'mrp',
  'kpi',
  'alertas',
  'parametrizacao',
  'follow-up-fornecedor',
  'geral'
]

interface CategoryFilterProps {
  selected: ArticleCategory[]
  onChange: (categories: ArticleCategory[]) => void
}

const CategoryFilter: FC<CategoryFilterProps> = ({ selected, onChange }) => {
  const isAllSelected = selected.length === 0

  const toggleCategory = (category: ArticleCategory) => {
    if (selected.includes(category)) {
      onChange(selected.filter(c => c !== category))
    } else {
      onChange([...selected, category])
    }
  }

  return (
    <HStack spacing={2} flexWrap="wrap">
      <Tag
        size="lg"
        cursor="pointer"
        variant={isAllSelected ? 'solid' : 'outline'}
        colorScheme="green"
        borderRadius="full"
        onClick={() => onChange([])}
      >
        <span>Todos</span>
      </Tag>
      {allCategories.map(category => {
        const isActive = selected.includes(category)
        return (
          <Tag
            key={category}
            size="lg"
            cursor="pointer"
            variant={isActive ? 'solid' : 'outline'}
            colorScheme={categoryColors[category]}
            borderRadius="full"
            onClick={() => toggleCategory(category)}
          >
            <span>{categoryLabels[category]}</span>
          </Tag>
        )
      })}
    </HStack>
  )
}

export default CategoryFilter
